import React, { createContext, useState, useContext, useEffect, useRef } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { useLocation } from "react-router-dom";
import axios from "axios";
import "./game.css"; 
import FloatingDiamond from './../pages/components/FloatingDiamond'; //
const GameContext = createContext();

export const useGame = () => useContext(GameContext);

export const GameProvider = ({ children }) => {
    // --- STATE GIAO DIỆN ---
    const [isGameActive, setGameActive] = useState(false);
    const [playGameUrl, setPlayGameUrl] = useState(null);
    const [gameTitle, setGameTitle] = useState("");
    const [activeGameId, setActiveGameId] = useState(null);

    // --- LOGIC NGẦM ---
    const activeProductIdRef = useRef(null); 
    const activeApiCodeRef = useRef(null);
    const activeCurrencyRef = useRef(null); // THÊM: Lưu tiền tệ (VND, IDR...)

    const [isClosing, setClosing] = useState(false);
    const location = useLocation();

    // Cấu hình Axios
    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) config.headers["Authorization"] = `Bearer ${token}`;
            return config;
        },
        (error) => Promise.reject(error)
    );

    // =================================================================
    // HÀM RÚT TIỀN TỰ ĐỘNG KHI ĐÓNG GAME HOẶC F5
    // =================================================================
    const autoWithdrawMoney = async (specificId = null, specificApiCode = null, specificCurrency = null) => {
        let currentId = specificId || activeProductIdRef.current || localStorage.getItem("STUCK_GAME_ID");
        let currentApiCode = specificApiCode || activeApiCodeRef.current || localStorage.getItem("STUCK_API_CODE");
        let currentCurrency = specificCurrency || activeCurrencyRef.current || localStorage.getItem("STUCK_CURRENCY") || "VND";
        
        if (!currentId || !currentApiCode) return;
        currentId = String(currentId);

        try {
            // 1. Quét xem trong sảnh game còn bao nhiêu tiền (Gửi kèm api_code, currency)
            const resBalance = await axios.post(`${process.env.REACT_APP_API_URL}/casino/getbalance`, { 
                product_type: currentId,
                api_code: currentApiCode,
                currency: currentCurrency // <--- Bổ sung gửi currency
            });
            
            const rawBalance = Number(resBalance.data?.data?.balance || 0);
            
            // ÉP VỀ SỐ NGUYÊN TỐI ĐA
            const moneyToWithdraw = Math.floor(rawBalance);

            if (moneyToWithdraw > 0) {
                try {
                    await axios.post(`${process.env.REACT_APP_API_URL}/casino/transfer`, {
                        product_type: currentId,
                        api_code: currentApiCode,
                        currency: currentCurrency, // <--- Bổ sung gửi currency
                        type: 2, // 2 = RÚT RA
                        money: moneyToWithdraw 
                    });
                    console.log(`[Auto-Withdraw] Rút thành công ${moneyToWithdraw} từ sảnh ${currentApiCode}`);
                } catch (errTransfer) {
                    console.error("[Auto-Withdraw] Lỗi khi đang rút tiền:", errTransfer);
                }
            }
        } catch (error) {
            console.error("[Auto-Withdraw] Lỗi khi check số dư sảnh:", error);
        } finally {
            activeProductIdRef.current = null;
            activeApiCodeRef.current = null;
            activeCurrencyRef.current = null;
            setActiveGameId(null);
            
            localStorage.removeItem("STUCK_GAME_ID");
            localStorage.removeItem("STUCK_API_CODE");
            localStorage.removeItem("STUCK_CURRENCY");
            
            // Kích hoạt event nhảy số dư
            setTimeout(() => {
                window.dispatchEvent(new Event("balanceUpdated"));
            }, 500);
        }
    };

    useEffect(() => {
        if (localStorage.getItem("user")) {
            autoWithdrawMoney();
        }
    }, []);
    const openGlobalGame = (url, title = "Casino", productId = null, apiCode = null, currency = "VND") => {
        if (url) {
            const strProductId = String(productId);
            const strApiCode = String(apiCode);
            
            setPlayGameUrl(url);
            setGameTitle(title);
            setGameActive(true);
            
            // Đánh dấu sảnh đang chơi
            activeProductIdRef.current = strProductId;
            activeApiCodeRef.current = strApiCode;
            activeCurrencyRef.current = currency; // <--- Lưu tiền tệ vào state
            setActiveGameId(strProductId); 
            
            if(strProductId) localStorage.setItem("STUCK_GAME_ID", strProductId);
            if(strApiCode) localStorage.setItem("STUCK_API_CODE", strApiCode);
            if(currency) localStorage.setItem("STUCK_CURRENCY", currency); // <--- Lưu tiền tệ vào đệm
        }
    };

    // --- HÀM ĐÓNG GAME ---
    const closeGlobalGame = async () => {
        if (isClosing) return;
        setClosing(true);
        
        setGameActive(false);
        setPlayGameUrl(null);
        setGameTitle("");

        // Chạy ngầm lệnh rút tiền
        await autoWithdrawMoney(); 

        setClosing(false);
    };

    return (
        <GameContext.Provider value={{ openGlobalGame, closeGlobalGame, isGameActive, activeGameId }}>
            {children}
             
            {/* GIAO DIỆN OVERLAY GAME */}
            {isGameActive && playGameUrl && (
                
                <div className="game-iframe-wrapper">
                        
                     

                       
                    
                    <iframe
                        src={playGameUrl}
                        className="game-iframe-screen"
                        title="Global Game Frame"
                        allowFullScreen
                        frameBorder="0"
                        sandbox="allow-scripts allow-same-origin allow-popups allow-forms allow-top-navigation-by-user-activation" 
                    ></iframe>
                    <FloatingDiamond />
                </div>
            )}
        </GameContext.Provider>
    );
};